import { render, staticRenderFns } from "./product_bankcard.vue?vue&type=template&id=1fb9f884&scoped=true"
import script from "./product_bankcard.vue?vue&type=script&lang=js"
export * from "./product_bankcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9f884",
  null
  
)

export default component.exports